import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Button, Box, Space, ActionIcon,Affix, Center, Paper, Overlay} from '@mantine/core';
import { IconSquareRoundedX } from '@tabler/icons';
import moment from 'moment'


import ContainerTranslation from "../partials/ContainerTranslation";

import { fetchRex, updateFieldRex, validate, addFieldRex, removeFieldRex } from '../../actions/rex';

import history from '../../history';
import { InputText } from '../input/InputText.tsx';
import { InputDate } from '../input/InputDate';
import {TextAreaLabeled} from '../input/TextAreaLabeled';
import AddButton from '../partials/AddButton';



var updateTimeout = {}


class FormContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isPopupOpen: false
    }
    this.props.fetchRex(this.props.match.params.id);
  }

  togglePopup() {
    if (this.state.isPopupOpen) {
      this.setState({ isPopupOpen: false })
    }
    else {
      this.setState({ isPopupOpen: true })
    }
  }



  scrollTop() {
    window.scrollTo(0, 0);
  }

  string2Date(date){
    return date ? new Date(Date.parse(moment(date, 'DD/MM/YYYY').toISOString())) : null
  }


  addField(path){
    const objToReturn =  {"recommandation":"", "author":"", "closure-date":"", "DDC":""}
    this.props.addFieldRex(objToReturn, path, this.props.match.params.id);
  }

  removeField(i, path) {
    this.props.removeFieldRex(i, path, this.props.match.params.id);
  }


  componentDidUpdate(prevProps) {
    if (this.props.message === 'Rex has been validated') {
      history.push('/rex/' + this.props.rex._id);
    }

  }


  handleInputChange(obj, isValid, withTimeout) {
    
    var _this = this

    if (withTimeout) {
      clearTimeout(updateTimeout[obj.name]);
      updateTimeout[obj.name] = setTimeout(function () {
        delete updateTimeout[obj.name]
        _this.props.updateFieldRex(obj, _this.props.match.params.id);
      }, 1000)
    } else {
      _this.props.updateFieldRex(obj, _this.props.match.params.id);
    }

  }

  handleDateChangeFactory(name,parent,index){
    const _this = this
    function handleChangeDate(date){

      if (date === null || date === undefined){
        return _this.props.updateFieldRex({name:name,parent:parent,index:index,value:null}, _this.props.match.params.id);
      }
      const parseddate = new Date(date) 
      const formattedDate = parseddate !== "Invalid Date" ? moment(parseddate).format('DD/MM/YYYY') : null

      return _this.props.updateFieldRex({name:name,parent:parent,index:index,value:formattedDate}, _this.props.match.params.id);
    }
    return handleChangeDate
  }


  handleBlurFactory(parent,index){

    const handleBlur = (e) => {
      this.props.updateFieldRex({name : e.target.name, value : e.target.value, parent : parent,  index : index}, this.props.match.params.id);
    }
    return handleBlur
  }


  getPlaceHolder(path){

    const observation = "Observation et analyse des causes.\n" +
    "Analysez les facteurs d’échec et de succès sous les angles de la technique, du management et des aspects organisationnels."
    const recommandation = "Formulez des recommandations permettant de répondre aux causes du dysfonctionnement"

    const details = "Si oui, préciser \n"+
    "- Bonnes pratiques techniques :\n"+
    "- Points de vigilance :\n"+
    "- Base de données d’éléments standards :\n"+
    "- Outils d’automatisation :\n"+
    "- Autres :"

    const placeHolder = {
      'requirements':{
        'problematic':{
          'overview':"Analyse du besoin du client (problématique, spécificités du projet…)\n  " +
          "•	Avez-vous eu connaissance du cahier des charges ? → \n " +
          "•	La problématique du projet était-elle claire, bien définie ? → \n "+
          "•	Les contraintes (technique, planning…) étaient-elles identifiées ? → ",
          'observation':observation,
          'recommandation':recommandation   
        },
        'answer':{
          'overview':"Réponse à la demande du client\n  "+
          '•	Avez-vous eu connaissance de la réponse IKOS au cahier des charges (contenu et nombre de jours/heures…) →\n'+
          '•	Avez-vous été impliqué dans la rédaction de la réponse ? → \n'+
          '•	Les contraintes (technique, planning (durée, délai, jalons…)…) étaient-elles identifiées ? →',
          'observation':observation,
          'recommandation':recommandation 
        }
      },
      'project':{
        'input':{
          'overview':"Données d’entrée (DE)\n"+
          "•	Avez-vous reçu toutes les données d’entrée :\n"+
          "\t o	nécessaires au projet ? → \n"+
          "\t o	de la liste définie au début de projet ? →\n"+
          "•	le type ou format de la DE était-il exploitable ? →\n"+
          "•	La date de réception était-elle en adéquation avec le planning projet ? →\n"+
          "•	Avez-vous réalisé une analyse de risques si une donnée d’entrée était absente ? →",
          'observation':observation,
          'recommandation':recommandation    
        },'equipment':{
            'overview':"Les moyens matériels mis à disposition étaient-ils suffisants pour mener à bien le projet ?\n"+
            "•	matériel de bureau (ordinateur,…) →\n"+
            "•	matériel informatique (logiciel,…) →\n"+
            "•	reprographie, impression… →",
            'observation':observation,
            'recommandation':recommandation     
        },'planning':{
            'overview':"Planning projet\n"+
            "•	A-t-il été défini ? →\n"+
            "•	Quel était le niveau de détails ? (date de rendu, jalons, étapes clés du projet, tâches…) →\n"+
            "•	Avez-vous respecté le planning projet ? →\n"+
            "•	A-t-il été sur ou sous-évalué ? →",
            'observation':observation,
            'recommandation':recommandation  
        },'payload':{
            'overview':"Livrables/Qualité\n"+
            "•	Les livrables attendus étaient-ils bien définis ? →\n"+
            "•	Les supports livrables (type fichier, format, chartes graphiques…) ont-ils été bien définis ? →\n"+
            "•	Les docs PAQ (Plan d’Assurance Qualité) ont-ils été bien remplis ? →",
            'observation':observation,
            'recommandation':recommandation  
        },'problems':{
            'overview':"Y a-t-il eu des aléas pendant le projet ? →\n"+
            "•	Côté client :\n"+
            "\t o	Les objectifs ont-ils évolué au cours du projet ? →\n"+
            "\t o	Absence →\n"+
            "\t o	Autres →\n"+
            "•	Côté Ikos :\n"+
            "\t o	Panne informatique →\n"+
            "\t o	Absence →\n"+
            "\t o	Autres →",
            'observation':observation,
            'recommandation':recommandation  
        },
      },
        'management':{
          'internal-organization':{
              'overview':"Fonctionnement de l’organisation interne IKOS (consultants, ingénieur d’affaires, qualité, Ikos lab, équipe support,…)\n"+
              "•	Etait-elle bien définie ? → \n"+
              "•	L’encadrement du projet était-il excessif ou insuffisant ? → \n"+
              "•	Réactivité du/des consultant(s) producteur(s) face aux demandes de l’ingénieur d’affaires →\n"+
              "•	Réactivité de l’ingénieur d’affaires face aux demandes de l’équipe productrice ou du consultant producteur → \n"+
              "•	Réactivité du référent technique s’il était désigné → \n"+
              "•	Comment se faisait la communication interne au sein de l’équipe projet ? (téléphone, mail, réunion journalière, hebdomadaire, mensuelle…) →",
              'observation':observation,
              'recommandation':recommandation   
          },
          'ikos-team':{
              'overview':"En cas de projet en équipe IKOS \n"+
              "Définition de l’organisation des consultants producteurs \n"+
              "•	La répartition des rôles/tâches était-elle bien définie ? →",
              'observation':observation,
              'recommandation':recommandation  
          }
        },
        'client-relationship':{
          'communication':{
              'overview':"Communication Client/IKOS \n"+
              "•	Quelle était la fréquence des réunions ? Etait-elle suffisante/adaptée au projet ? →\n"+
              "•	Quel était le support des CR de réunion ? était-il adapté au projet ? →\n"+
              "•	Alerte des risques (technique, planning, coût…) →\n",
              'observation':observation,
              'recommandation':recommandation  
          },
          'contract':{
              'overview':"Contrat\n"+
              "•	L’évaluation de la satisfaction client a-t-elle été réalisée ? →",
              'observation':observation,
              'recommandation':recommandation  
          },
        },
        'result':{
          'objectives':{
              'overview':"Les objectifs initiaux ont-ils été remplis ? → \n"+
              "Selon vous, le projet constitue-t-il un succès complet ? →",
              'observation':observation,
              'recommandation':recommandation  
          },
          'follow-up':{
              'overview':"Y a-t-il eu des reprises sur des livrables par les consultants Ikos suite à des remarques clients ? Si oui, pour quelles raisons →",
              'observation':observation,
              'recommandation':recommandation  
          },
          'deadlines':{
              'overview':"Les délais, et les jalons ont-ils été respectés ? →",
              'observation':observation,
              'recommandation':recommandation  
          },                    
          'others':{
              'overview':"Les délais, et les jalons ont-ils été respectés ? →",
              'observation':observation,
              'recommandation':recommandation  
          },
        },

      'previous-rex':{
        'overview':"Avez-vous reçu un package technique de la part d’IKOS au démarrage de votre projet ? ",
        'details':details,
        'feedback':"Feedback sur les outils reçus :\n"+
        "-	Les avez-vous utilisés dans le cadre de votre projet ? (si non, pourquoi) :\n"+
        "-	Les avez-vous modifiés / améliorés pour votre besoin ?\n"+
        "-	Avez-vous des remarques/suggestions pour les améliorer ?"
      },
      'current-rex':{
        'overview':"Quels outils/méthodes/bonnes pratiques avez-vous utilisé pour la réalisation de votre projet ?\n"+
"Avez-vous également développé pour votre projet de nouveaux outils/méthodes/formations/bonnes pratiques améliorant votre efficacité ? ",
        'details':details,
        'feedback':"Avez-vous des suggestions d’outils, méthodes, bonnes pratiques pouvant être développés pour un même type de projet ? "
      },
      'skills':{
        'overview':"Les compétences étaient-elles suffisantes pour mener à bien le projet ?\n"+
        "•	Vos connaissances techniques étaient-elle suffisantes ? →\n"+
        "•	Y avait-il suffisamment de ressources allouées au projet ? →\n"+
        "•	Le support technique de la part d’IKOS était-il adapté ? →",
        'observation':observation,
        'recommandation':recommandation 
      },
      'technology-watch':{
        'overview':"Avez-vous utilisé ou eu connaissance au cours de votre projet de nouvelles techniques / technologies / méthodologies ou de sujets innovants ?",
        'details':"Nouvelles techniques, nouvelles technologies, nouvelles méthodologies ", 
      },
    }

    return _.get(placeHolder,path)
  }

  handleDocumentValidation(obj){
    var _this = this;
    _this.props.validate(obj,_this.props.rex._id);
  }


  renderValidate() {
    if(!localStorage.user || !this.props.rex.authorization || !this.props.rex.authorization.validate){
      return null;
    }


    if(this.props.rex.progression !== 100){
      return(
        <Button data-disabled onClick={(event) => event.preventDefault()}>
          {this.props.translate("content.information.document-validation-status.contexte")}
        </Button>
      )
    }

    if(this.props.rex.progression === 100 && this.state.isPopupOpen === false){
      return(
        <div className="btn-dashboard"> 
          <button style={{ width: "200px" }} className="primary-btn"   onClick={ () => {this.togglePopup()} } >   
            Valider le document    
          </button>      
        </div>
      )
    }

    if(this.props.rex.progression === 100 && this.state.isPopupOpen){
      return(
        <div>
          <>
            <Overlay color="#000" backgroundOpacity={0.85} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }} />
          </>
          <Affix position={{ bottom: (window.innerHeight)/2, left: (window.innerWidth -258.28)/2 }}>
          <div style={{position:"absolute", top:-18,right:-18}}>
              <ActionIcon variant="filled" radius="xl" size="xl" color="red">
              <IconSquareRoundedX onClick={ () => this.togglePopup()} style={{ width: '70%', height: '70%' }} />
              </ActionIcon>
          </div>
          <Box >
            <Paper shadow="md" radius="xl" p="xl">
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <ContainerTranslation id={"nav." + ['Validate context']}/>
              </div>
              <Space h="xs" />
              <Center>
                <div className="btn-dashboard"> 
                  <button style={{ width: "200px" }} className="primary-btn"  onClick={() => { this.handleDocumentValidation(); this.props.history.goBack(); }} >   
                    Valider le document    
                  </button>      
                </div>
              </Center>
            </Paper>
          </Box>
          </Affix>
        </div>
      )
    }
  }


  renderInputTextInformation(field){
    return (              
      <div className={"formulaire-field text"}>
        <InputText
          onBlur={this.handleBlurFactory('information')}
          value={this.props.rex.content['information'][field]}
          name={field}
          label={{title : field}}
        />
    </div>)
  }

  renderInputTextArea(field,path){

    const fieldPath = `${path}.${field}`

    return (              
      <div key = {"renderInputTextArea.div"+ field + '.' + path} className={"formulaire-field textarea"}>
        <TextAreaLabeled
          onBlur={this.handleBlurFactory(path)}
          value={_.get(this.props.rex.content,fieldPath)}
          name = {field}
          label={{title :field}}
          placeholder={this.getPlaceHolder(fieldPath)}
          maxLength={2600}
          height={'300px'}
        />
    </div>)
  }


  renderSection(fields,path){
    return (       
      <div className={"formulaire wide"}>      
        <h3>{path}</h3>
        {_.map(fields,(field)=>{
          return (
            <div key = {"renderSection.div"+ field + '.' + path}>
            <h4 key = {"renderSection.h4"+ field + '.' + path}>{field}</h4>
            {this.renderInputTextArea(field,path)}
            </div>
            )
        })}
      </div> 
    )
  }

  renderSectionWithRecommandation(path){
    return (       
      <div className={"formulaire wide"}> 
        <h4>{path.split('.')[1]}</h4>     
        <div>
          {this.renderInputTextArea('overview',path)}
        </div>
        <div>
          {this.renderInputTextArea('observation',path)}
        </div>
        <div>
          Recommandation
          {this.renderRecommandation(_.get(this.props.rex.content,`${path}.recommandation`),`${path}.recommandation`)}
        </div>
      </div>       
    )
  }


  renderRecommandation(recommandations,path) {
    let contents = []
    let _this = this

    _.each(recommandations, function (recommandation, i) {
      let keySuffix = i + Date.now()
      if (i >= 0) {
          contents.push(<div key={'separator-' + keySuffix} className="separator">
              <div className="delete-part" onClick={_this.removeField.bind(_this, i, path)}
                  key={'recommandation-remove-' + path + keySuffix}
                  id={'recommandation-remove-' + path + keySuffix}>
                  <i className="fas fa-trash" style={{ color: '#ffffff' }}></i>
              </div>
          </div>)
      }

      contents.push(<div key={'recommandation0-author-' +  keySuffix}>
                      <div key={'recommandation1-author-' +  keySuffix}  style={{ width: '100%' , paddingBlock : '10px'}}>
                      <div className={"inline"} style={{width:'30%'}} >Personne en charge : </div>
                      <div className={"inline"} style={{width:'50%'}} >
                        <InputText
                          onBlur={_this.handleBlurFactory(path,i)}
                          value={recommandation.author}
                          name={'author'}
                        />
                      </div>
                      <div className={"inline"} style={{width:'20%'}} ></div>
                      </div>
                      <div key={'recommandation1-closure-date-' + keySuffix} className={"inline"} style={{ width: '50%' }}>
                      <p style={{color:'black'}}>
                        Date de cloture attendue
                      </p>
                      <InputDate
                        locale={_this.props.translate('content.localisation')}
                        onChange={_this.handleDateChangeFactory('closure-date',path,i)}
                        value={_this.string2Date(recommandation['closure-date'])}
                      />
                      </div>
                      <div key={'recommandation1-DDC' + keySuffix} className={"inline"} style={{ width: '50%' }}>
                      <p style={{color:'black'}}>
                        DDC
                      </p>
                      <InputDate
                        locale={_this.props.translate('content.localisation')}
                        onChange={_this.handleDateChangeFactory('DDC',path,i)}
                        value={_this.string2Date(recommandation['DDC'])}
                      />
                      </div>
                      <div key={'recommandation1-recommandation-' + keySuffix} style={{ width: '100%', paddingBlock : '10px' }}>
                      <TextAreaLabeled
                            onBlur={_this.handleBlurFactory(path,i)}
                            name={"recommandation"}
                            value={recommandation.recommandation}
                            label={{title :"recommandation"}}
                            placeholder={""}
                            maxLength={1000}
                            height={'100px'}
                      />
                      </div>
                    </div>)

    })

    contents.push(<div key={'team-duplicate'} onClick={_this.addField.bind(_this,path)} className="duplicate" >
      <AddButton />
    </div>)

    return (
        <div className={"formulaire-field text"}>
          {contents}
        </div>
    )

  }



  render() {



    var route = "/rex/" + this.props.match.params.id

    var name = "Rex"
    var subname = "Formulaire"


    if (this.props.rex && Object.keys(this.props.rex).length === 0) {
      return (
        <h3>Loading...</h3>
      )
    } 


    return (

      <div className="formulaires">
        <div style={{color:"red"}}>*Fonctionnalité en cours de développement</div>
        <div className="formulaires-header">
          <h2>{name}</h2>
          <p style={{ margin: 0, textAlign: 'center' }}>{subname}</p>
          <span className="link-back"><Link to={route}><i className="fas fa-arrow-left" style={{ color: "#E30119", marginRight: "10px" }}></i><ContainerTranslation id={"nav.Back"} /></Link></span>
        </div>


        {/*NEW FORM*/}

        {/*INFORMATIONS*/}
        <div className="formulaire-section">

          <div className="formulaire-header">
            <h2>General information </h2>
          </div>
          {this.renderInputTextInformation('name') }
          {this.renderInputTextInformation('lastname') }
          {this.renderInputTextInformation('firstname') }
          {this.renderInputTextInformation('trade') }
          {this.renderInputTextInformation('client') }
          {this.renderInputTextInformation('domain') }
          {this.renderInputTextInformation('localisation') }
          {this.renderInputTextInformation('sector') }
          {this.renderInputTextInformation('sub-sector') }
          {this.renderInputTextInformation('duration') }
          {this.renderInputTextInformation('teamsize') }
          {this.renderInputTextInformation('typology') }
          {this.renderInputTextInformation('practice') }
        </div>



        {/*NOTES*/}
        <div className="formulaire-section">
          <div className="formulaire-header">
            <h2>Avant le projet : la commande </h2>
          </div>
          {this.renderSectionWithRecommandation("requirements.problematic")}
          {this.renderSectionWithRecommandation("requirements.answer")}
        </div>

        <div className="formulaire-section">
          <div className="formulaire-header">
            <h2>Le projet </h2>
          </div>
          {this.renderSectionWithRecommandation("project.input")}
          {this.renderSectionWithRecommandation("project.equipment")}
          {this.renderSectionWithRecommandation("project.planning")}
          {this.renderSectionWithRecommandation("project.payload")}
          {this.renderSectionWithRecommandation("project.problems")}
        </div>

        <div className="formulaire-section">
          <div className="formulaire-header">
            <h2>Management – Organisation interne </h2>
          </div>
          {this.renderSectionWithRecommandation("management.internal-organization")}
          {this.renderSectionWithRecommandation("management.ikos-team")}
        </div>

        <div className="formulaire-section">
          <div className="formulaire-header">
            <h2>Relation client </h2>
          </div>
          {this.renderSectionWithRecommandation("client-relationship.communication")}
          {this.renderSectionWithRecommandation("client-relationship.contract")}
        </div>

        <div className="formulaire-section">
          <div className="formulaire-header">
            <h2>Résultats </h2>
          </div>
          {this.renderSectionWithRecommandation("result.objectives")}
          {this.renderSectionWithRecommandation("result.follow-up")}
          {this.renderSectionWithRecommandation("result.deadlines")}
          {this.renderSectionWithRecommandation("result.others")}
        </div>

        <div className="formulaire-section">
          <div className="formulaire-header">
            <h2>Utilisation du REX des précédents projets </h2>
          </div>
          {this.renderSection(['overview','details','feedback'],"previous-rex")}
        </div>

        <div className="formulaire-section">
          <div className="formulaire-header">
            <h2>REX de votre projet</h2>
          </div>
          {this.renderSection(['overview','details','feedback'],"current-rex")}
          {this.renderSectionWithRecommandation("skills")}
          {this.renderSection(['overview','details'],"technology-watch")}
        </div>


        {/*END NEW FORM*/}

        <div className="btn-dashboard">
          <p>{this.props.rex.progression ? this.props.rex.progression : 0}<ContainerTranslation id={"nav." + ['completed']} /></p>
          <div>
            <Link to={route}><button className="primary-btn"><ContainerTranslation id={"nav." + ['Back to the dashboard']} /></button></Link>
          </div>
          <div className="renderValidate" >
              {this.renderValidate()}
          </div>
        </div>




        <div className="scrollTop" onClick={this.scrollTop.bind(this)}>
          <i className="fas fa-arrow-up" style={{ color: "#E30119" }}></i>
        </div>
      </div>
    )
  
  }
}




const mapStateToProps = state => ({
  rex: state.rex.rex,
  message: state.rex.message
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchRex, updateFieldRex, validate, addFieldRex, removeFieldRex
}, dispatch); 

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(FormContainer)));
